var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sum.indexOf(_vm.field.column) !== -1)?_c('td',{class:{ 'text-center': _vm.field.align === 'center' }},[_vm._v(_vm._s(_vm.fieldsSum))]):_c('td',[_vm._v(" ")])}
var staticRenderFns = []

export { render, staticRenderFns }